module.exports = __webpack_public_path__ + "static/media/squirrelflame.90ce1f9b.png";